<template>
    <div class="employee-item">
        <div class="employee-item__inner">
            <ResponsiveImage v-if="employee.ImageHtml.Src || employee.ImageHtml.HasCrop" :imageModel="employee.ImageHtml" wrapClass="employee-item__image" />
            <div class="employee-item__info-wrap">
                <div class="employee-item__info">
                    <div class="employee-item__row">
                        <h3 class="employee-item__name">{{ employeeItem.Name }}</h3>
                        <p class="employee-item__title" v-if="employeeItem.HasTitle">
                            <span class="employee-item__title-name">{{ employeeItem.Title }}</span>
                            <span class="employee-item__title-segment" v-if="employeeItem.HasSegments"
                                :style="{ 'color': employeeItem.Segments[0].Color }">{{ employeeItem.Segments[0].Label
                                }}</span>
                        </p>
                    </div>
                    <div class="employee-item__row"
                        v-if="employeeItem.HasPhone || employeeItem.HasMobile || employeeItem.HasEmail">
                        <p class="employee-item__text" v-if="employeeItem.HasPhone">
                            {{ dictionaries.EmployeePhone }} <a :href="'tel:' + employeeItem.Phone"
                                class="employee-item__link">{{ employeeItem.Phone }}</a>
                        </p>
                        <p class="employee-item__text" v-if="employeeItem.HasMobile">
                            {{ dictionaries.EmployeeMobile }} <a :href="'tel:' + employeeItem.Mobile"
                                class="employee-item__link">{{ employeeItem.Mobile }}</a>
                        </p>
                        <p class="employee-item__text" v-if="employeeItem.HasEmail">
                            {{ dictionaries.EmployeeEmail }} <a :href="'mailto:' + employeeItem.Email"
                                class="employee-item__link">{{ employeeItem.Email }}</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ResponsiveImage from "./responsiveImage.vue";
export default {
    name: "employeeItem",
    components: {
        ResponsiveImage
    },
    props: ["employeeItem", "dictionaries"]
};
</script>